namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxTreeTaxRow {
        Id?: string;
        DocDate?: string;
        PosId?: string;
        PosPermitNo?: string;
        HdDtFg?: number;
        DocType?: number;
        TaxInvoiceNo?: string;
        RefRecieptNo?: string;
        StartDocNo?: string;
        EndDocNo?: string;
        BuyerName?: string;
        TaxId?: string;
        BranchName?: string;
        DocAmt?: number;
        NonVatAmt?: number;
        TotalAmt?: number;
        ExVatAmt?: number;
        VatAmt?: number;
    }

    export namespace ReportSaleTaxTreeTaxRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PosId';
        export const localTextPrefix = 'PosShift.ReportSaleTaxTreeTax';
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            PosId = "PosId",
            PosPermitNo = "PosPermitNo",
            HdDtFg = "HdDtFg",
            DocType = "DocType",
            TaxInvoiceNo = "TaxInvoiceNo",
            RefRecieptNo = "RefRecieptNo",
            StartDocNo = "StartDocNo",
            EndDocNo = "EndDocNo",
            BuyerName = "BuyerName",
            TaxId = "TaxId",
            BranchName = "BranchName",
            DocAmt = "DocAmt",
            NonVatAmt = "NonVatAmt",
            TotalAmt = "TotalAmt",
            ExVatAmt = "ExVatAmt",
            VatAmt = "VatAmt"
        }
    }
}
